export default "__VITE_ASSET__a298573a__"